// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\r\n  /* font-family: Avenir, Helvetica, Arial, sans-serif; */\r\n\tfont-family: \"Varela Round\",\"Open Sans\",\"Helvetica Neue\",Arial,sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  text-align: center;\r\n  color: #2c3e50;\r\n  margin-top: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;
